import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'

function useMutationDeleteIntervalMessage(
	props?: UseBaseMutationOptions<void, string>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.DeleteIntervalMessage],
		mutationFn: (id: string) => MessagingService.deleteIntervalMessage(id),
		...props,
	})
}

export default useMutationDeleteIntervalMessage
